module.exports = __webpack_public_path__ + "files/aa3345e73f9f4fcd29f540bd8f2e709b.svg";